import { ColumnsType } from 'antd/lib/table';
import { handleNullValues } from 'components/ui/base/table/TableUtils';
import { IrelandExportItem } from 'store/declarations/ireland/export-declaration';
import getItemNumberColumn from 'views/declarations/common/getItemNumberColumn';

const getExportProductsTableColumns = (
    getNameFromCountryCode: (code?: string) => string | undefined
): ColumnsType<any> => [
    getItemNumberColumn((record: IrelandExportItem) => record.declarationGoodsItemNumber),
    {
        title: 'Code & Description',
        key: 'commodity_code',
        render: (_, record: IrelandExportItem) => {
            const code = record?.commodity?.commodityCode?.combinedNomenclatureCode;
            const description = record?.commodity?.descriptionOfGoods;
            return (
                <div>
                    <div>{handleNullValues(code)}</div>
                    {description != null && <div>{handleNullValues(description)}</div>}
                </div>
            );
        },
        sorter: true,
    },
    {
        title: 'Country of Origin',
        key: 'country_of_origin',
        render: (_, record: IrelandExportItem) => getNameFromCountryCode(record?.origin?.countryOfOrigin) ?? '-',
    },
    {
        title: 'Item Price',
        dataIndex: 'item_price',
        key: 'item_price',
        render: () => '-',
    },
];

export default getExportProductsTableColumns;
